<div id="main-content" *ngIf="afOtherBgcInfo ; else loading" class="wrapper has-padding margin-height zoom-margin" (focusout)="onFocusOutMainContent($event)">
  <form [formGroup]="otherData">

    <div [innerHTML]="afOtherBgcInfo.firstSection"></div>

      <div>
        <div class="bottom-space">
          <div class="container display-flex flex-wrapper">
            <div class="has-background cool-gray-5 flex-space flex-space-ie fx-flex-100">
              <div class="has-padding">

               <div [innerHTML]="afOtherBgcInfo.californiaOne"></div>

                <mat-radio-group class="bofa--heading is-10 radio-color" aria-label="Select an option"
                  formControlName="isCAStateDisclosure">
                  <mat-radio-button class="minor-list-space" matInput value="1" name="california">Yes, I would like a copy of my consumer report</mat-radio-button>
                  <mat-radio-button matInput value="2" name="california">No, I do not want a copy</mat-radio-button>
                </mat-radio-group>

                <div [innerHTML]="afOtherBgcInfo.californiaTwo"></div>

                <a class="bofa--heading is-9 link" (click)="openSummaryOfRights($event)">(Summary of Rights to Obtain Additional Information)</a>
                </div>
            </div>

            <div class="has-background cool-gray-5 flex-space flex-space-ie fx-flex-100">
              <div class="has-padding">

                <div [innerHTML]="afOtherBgcInfo.maryland"></div>

              </div>
            </div>
            <div class="has-background cool-gray-5 fx-flex-100">
              <div class="has-padding">

                <div [innerHTML]="afOtherBgcInfo.massachusetts"></div>

              </div>
            </div>
          </div>
        </div>

        <div class="bottom-space">
          <div class="container display-flex flex-wrapper">
            <div class="has-background cool-gray-5 flex-space flex-space-ie fx-flex-100">
              <div class="has-padding">

                  <div [innerHTML]="afOtherBgcInfo.minnesotaOne"></div>

                <mat-radio-group class="bofa--heading is-10 radio-color" aria-label="Select an option"
                  formControlName="isMNStateDisclosure">
                  <mat-radio-button class="minor-list-space" matInput value="1" name="minnesota">Yes, I would like a copy
                    of my consumer report</mat-radio-button>
                  <mat-radio-button matInput value="2" name="minnesota">No, I do not want a copy</mat-radio-button>
                </mat-radio-group>

                <div [innerHTML]="afOtherBgcInfo.minnesotaTwo"></div>

              </div>
            </div>
            <div class="has-background cool-gray-5 flex-space flex-space-ie fx-flex-100">
              <div class="has-padding">

                <div [innerHTML]="afOtherBgcInfo.newYork"></div>

              </div>
            </div>
            <div class="has-background cool-gray-5 fx-flex-100">
              <div class="has-padding">

                <div [innerHTML]="afOtherBgcInfo.nyc"></div>

              </div>
            </div>
          </div>
        </div>

        <div class="container display-flex flex-wrapper">
          <div class="has-background cool-gray-5 flex-space flex-space-ie fx-flex-100">
            <div class="has-padding">

              <div [innerHTML]="afOtherBgcInfo.oklahoma"></div>

              <mat-radio-group class="bofa--heading is-10 radio-color" aria-label="Select an option"
                formControlName="isOKStateDisclosure">
                <mat-radio-button class="minor-list-space" matInput value="1" name="oklahoma">Yes, I would like a copy
                  of my consumer report</mat-radio-button>
                <mat-radio-button matInput value="2" name="oklahoma">No, I do not want a copy</mat-radio-button>
              </mat-radio-group>

            </div>
          </div>
          <div class="has-background cool-gray-5 flex-space flex-space-ie fx-flex-100">
            <div class="has-padding">

              <div [innerHTML]="afOtherBgcInfo.rhodeIsland"></div>

            </div>
          </div>
          <div class="has-background cool-gray-5 fx-flex-100">
            <div class="has-padding">

              <div [innerHTML]="afOtherBgcInfo.vermont"></div>

            </div>
          </div>
        </div>
      </div>

      <div>

        <div [innerHTML]="afOtherBgcInfo.lastSection"></div>

      </div>

    <div class="sig-container" *ngIf="afOtherBgcInfo">
      <app-wet-signature [signatureImg]="signatureImg" (sigURL)="getUrl($event)" (sigCheck)="sigCheck($event)"></app-wet-signature>
      <mat-error *ngIf="output.hasError('invalid') || sigCheckValue"> Please enter electronic signature </mat-error>
    </div>

    <mat-checkbox formControlName="otherBgcLegalRequirementsMet" class="minor-check-padding" aria-required="true" required (focusout)="legalOnBlur()"
    (focusin)="legalOnFocus()">
      <mat-label><abbr title="required">* </abbr>Yes, I agree that I have fully reviewed and
        completed the information above
      </mat-label>
    </mat-checkbox>
    <mat-error *ngIf="otherBgcLegalRequirementsMet.hasError('invalid') && check"> Please check the box to agree to the above language </mat-error>

    <div>
      <mat-form-field class="max-zoom full-name-field" hideRequiredMarker>
        <mat-label><abbr title="required">* </abbr>Please enter your full name</mat-label>
        <input matInput placeholder="Full name" formControlName="otherBgcApplicantSignedName" required maxlength="250">
        <mat-error>Please enter your full name</mat-error>
      </mat-form-field>
    </div>

    <div>
      <mat-form-field class="max-zoom date-signed">
        <mat-label>Date Signed</mat-label>
        <input value="{{ date }}" matInput disabled>
      </mat-form-field>
    </div>
  </form>
</div>

<ng-template #loading>
  Loading Other Background Information...
</ng-template>
